import { useGetConfigByType } from '@r/hooks/use-workspace-config.ts';
import { FileXIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card } from '@ui/card.tsx';

const PdfViewer = ({ mediaKey }: { mediaKey: string }) => {
  const { t } = useTranslation();
  const pdf = useGetConfigByType('media', mediaKey)?.[0];

  let response = (
    <div className="flex min-h-[50vh] w-full grow flex-col items-center justify-center rounded-3xl bg-muted-foreground">
      <FileXIcon className="mb-3 text-muted" size={80} />
      <span className="text-2xl font-bold text-muted">{t('pdf.viewer.file.not.found')}</span>
    </div>
  );

  if (pdf) {
    response = (
      <Card className="min-h-[60vh] w-full grow overflow-hidden">
        <iframe src={pdf} className="w-full h-full" title={t('Document PDF')} />
      </Card>
    );
  }

  return <div className="flex overflow-hidden px-7 pt-6 grow">{response}</div>;
};

export default PdfViewer;
